"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Helpers
 */
var dcore = require("dcorejs-lib");
exports.dcorejs_lib = dcore;
function setLibRef(libRef) {
    exports.dcorejs_lib = libRef;
}
exports.setLibRef = setLibRef;
function getLibRef() {
    return exports.dcorejs_lib;
}
exports.getLibRef = getLibRef;
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/helpers.js
// module id = 21
// module chunks = 0